import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import UserLookup from '../../components/Form/UserLookup';
import VehicleLookup from '../../components/Form/VehicleLookup';
import ApiClient from '../../helpers/ApiClient';
import ProblemList from '../../containers/Checkpoint/PickerList';
import {ModalWindow} from 'reactis-modal';
import immutable from 'immutable';
import ClientLookup from "../../components/Form/ClientLookup";
import VehicleBox from '../Vehicle/Infobox';


class ProblemSubform extends React.Component {

	static contextTypes= {
		router: React.PropTypes.object
	};

	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	render() {
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td style={{width:60}}><FormField name="rating" /></td>
				<td><FormField name="text" /><FormField name="checkpoint" /></td>
				<td style={{width:60}}><i title="Odstranit"
					   onClick={this.props.onRemove}
					   onMouseOver={() => this.handleMouseOver()}
					   onMouseOut={() => this.handleMouseOut()}
					   className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
}

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid),
			user: state.auth.identity
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);
		this.api = {
			fetch: 'techtest.fetch',
			save: 'techtest.save',
			remove: 'techtest.delete'
		};

		this.changeEvent = 'techtest.change';

		this.messages = {
			remove: 'Opravdu si přejete technickou prohlídku odstranit?',
			notfound: 'Technická prohlídka nenalezena!'
		};

		this.schema = {
			number: {
				class: TextInput,
				label: 'Protokol č.',
				style: {width: 50},
				rules: {
					presence: {message: 'Protokol je povinná položka!'}
				}
			},
			year: {
				class: TextInput,
				label: 'Rok',
				style: {width: 60},
				rules: {
					presence: {message: 'Protokol je povinná položka!'}
				}
			},
			client: {
				class: ClientLookup,
				addButton: true,
				label: 'Firma',
				value: props.tab.args.firm,
				rules: {
					presence: {message: 'Firma je povinná položka!'}
				}
			},
			vehicle: {
				class: VehicleLookup,
				addButton: true,
				label: 'Vozík',
				value: props.tab.args.vehicle,
				dynamicProps: (data) => {
					return {
						client: data.client ? data.client.id : null
					}
				},
				rules: {
					presence: {message: 'Vozík je povinná položka!'}
				}
			},
			date: {
				class: DatePicker,
				width: 120,
				value: new moment().format('YYYY-MM-DD'),
				label: 'Datum'
			},
			date_to: {
				class: DatePicker,
				width: 120,
				value: new moment().add('year', 1).format('YYYY-MM-DD'),
				label: 'Datum'
			},
			km: {
				class: TextInput,
				label: 'Stav počítadla'
			},
			user: {
				class: UserLookup,
				label: 'Provedl',
				value: {id: this.props.user.id, text: this.props.user.surname + ' ' + this.props.user.name}
			},
			user_accept: {
				class: TextInput,
				label: 'Převzal'
			},
			notice: {
				class: TextInput,
				label: 'Poznámka'
			},
			files: {
				class: FileUpload,
				label: 'Přílohy'
			},
			items: {
				class: Multiform,
				className: 'techproblems multiform',
				label: 'Závady',
				addLabel: false,
				subform: ProblemSubform,
				schema: {
					rating: {
						class: Select,
						options: DbInfo.Rating,
						clearable: false,
						label: 'Úroveň'
					},
					text: {
						class: TextInput,
						label: 'Text',
						style: {width: 520}
					},
					checkpoint: {
						class: TextInput,
						type: 'hidden'
					}
				}
			}
		};
		this.form = new FormManager(this.schema);
		if (!this.props.id) {
			const client = new ApiClient();
			client.call('techtest.getDefaults').then((data) => {
				this.form.setValue(data);
			});
		}
	}

	componentDidMount() {
		this.form.on('change', (key, value, values) => {
			if (key == 'number' || key == 'year') {
				this.updateTab(values.toJS());
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.number + '/' + data.year});
	}

	pickProblem() {
		this.popupDriver = new ModalWindow(null, <ProblemList onAdd={(rating, text, checkpoint) => this.handleAddProblem(rating, text, checkpoint)} />);
		this.popupDriver.className = 'fullwidth';
		this.popupDriver.show(this.context.store.dispatch);
	}

	copyProblem() {
		const vehicle = this.form.getValues().getIn(['vehicle', 'id']);
		const api = new ApiClient();
		api.call('techtest.import', {id: parseInt(vehicle), tid: this.props.id}, {progress: true}).then((data) => {
			let items = this.form.getValues().get('items');
			if (!items) {
				items = immutable.List();
			}
			data.problems.forEach((item) => {
				items = items.push({id: -Math.random(), rating: parseInt(item.rating), checkpoint: item.checkpoint, text: item.text});
			});
			this.form.setValue({items:items.toJS()});
		}).error(() => {

		});
	}

    handlePrint(type) {
        const api = new ApiClient();
        api.call('techtest.download', {id: this.props.id, type}, {progress: true}).then((data) => {
            if (data) {
                const win = window.open(data.url, '_blank');
                if(win){
                    win.focus();
                }else{
                    alert('Povolte prosím v prohlížeči vyskakovací okna pro tuto aplikaci.');
                }
                //window.location = data.url;
            }
        });
    };

	handleAddProblem(rating = null, text = '', checkpoint = null) {
		let items = this.form.getValues().get('items');
		if (!items) {
			items = immutable.List();
		}
		items = items.push({id: -Math.random(), rating: rating, text: text, checkpoint: checkpoint});
		this.form.setValue({items:items.toJS()});
	}

	render() {

		const canEdit = true;
		const saveButton = <SaveButton
			disabled={!canEdit}
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save()}
		/>;

		const printButton = (
			<DropdownButton id="print" style={{marginLeft:5}} bsStyle="success" title={<span><i className="fa fa-print  position-left" />Tisk</span>}>
				<MenuItem onSelect={() => this.handlePrint(1)} eventKey="1">Protokol technické kontroly</MenuItem>
				<MenuItem onSelect={() => this.handlePrint(2)} eventKey="2">Příloha k protokolu</MenuItem>
				<MenuItem onSelect={() => this.handlePrint(3)} eventKey="3">Kontrolní body</MenuItem>
			</DropdownButton>
		);

		const btns = <ButtonToolbar>
			{saveButton}
			{this.props.id > 0 && <ActionButton disabled={!canEdit} bsStyle="danger" icon="fa fa-trash-o" onClick={()=>this.remove()}>
				Odstranit
			</ActionButton>}
            {this.props.id > 0 && printButton}
		</ButtonToolbar>;

		const vehicle = this.form.getValues().get('vehicle') ? this.form.getValues().get('vehicle').get('id') : null;

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Technická prohlídka" buttons={btns} />
					<div className="row">
						<div className="col-xs-8">
							<table className="form">
								<tbody>
								<FormRow label="Protokol č." labelWidth={135}>
									<FormField name="number" /> / <FormField name="year" />
								</FormRow>
								<FormRow name="client" />
								<FormRow name="vehicle" />
								<FormRow label="Datum">
									<FormField name="date" /> &nbsp; Platnost do <FormField name="date_to" />
								</FormRow>
								<FormRow name="km" />
								<FormRow name="user" />
								<FormRow name="user_accept" />
								<FormRow name="notice" />
								<FormRow name="files" />
								<tr>
									<th>
										Závady
									</th>
									<td>
										<FormField name="items" />
										<ButtonToolbar style={{float:'none', margin:'10px 0px'}}>
											<Button onClick={() => this.pickProblem()}><span className="fa fa-hand-pointer-o position-left"></span>vybrat závady</Button>
											<Button onClick={() => this.copyProblem()}><span className="fa fa-file-text-o position-left"></span>kopírovat z předchozí TK</Button>
											<Button onClick={() => this.handleAddProblem()}><span className="fa fa-plus position-left"></span>přidat závadu pro TK</Button>
										</ButtonToolbar>
									</td>
								</tr>
								</tbody>
							</table>
						</div>
						<div className="col-xs-4">
							<VehicleBox id={vehicle} />
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Techtest/Form.js